import * as Sentry from '@sentry/vue';

const ignorePaths404 = ['/inbox_members', '/config', '/widget/contact', '/widget/conversations'];

export const sendExceptionToSentry = err => {
  const status = err?.response?.status;
  if( status === 404 ){
    const url = err?.response?.config?.url;
    if (!!url && ignorePaths404.some(path => url.includes(path))){
      console.debug({ drop: { url, status: 404 } });
      return;
    }
  }
  const urlParams = new URLSearchParams(window.location.search);
  const currentToken = urlParams.get('website_token');
  const disabledTokens = process.env.VUE_APP_SENTRY_DISABLED_WEBSITE_TOKENS.split(
    ','
  ).map(token => token.trim());
  if (currentToken && !disabledTokens.includes(currentToken)) {
    try {
      Sentry.captureException(err);
    } catch (err) {
      console.log('Sending error to sentry failed...', err);
    }
  }
};
